import React, { useEffect, useState } from 'react';

import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import FreeAccountCreateTable from '@components/common/Table/FreeAccountCreateTable';
import api from '@api/axios';
import { useNavigate } from 'react-router-dom';
import { useDialog } from '@context/DialogContext';
const FreeAccountCreate = () => {
  const { showDialog } = useDialog();
  const navigate = useNavigate();

  // 개인사업자 ID
  const id = new URLSearchParams(window.location.search).get('id') || null;

  // 사업자 정보
  const [param, setParam] = useState({
    personName: '',
    phone: '',
    email: '',
    bank: '',
    accountNumber: '',
    identityFile: null,
    bankbookFile: null,
  });

  // 저장
  const handleSave = async () => {
    if (param.personName === '') {
      showDialog({ title: '확인', message: '이름을 입력해 주세요.' });
      return;
    }
    if (param.phone === '') {
      showDialog({ title: '확인', message: '전화번호를 입력해 주세요.' });
      return;
    }

    const identityFile = param.identityFile;
    const bankbookFile = param.bankbookFile;
    const selectedFiles = [identityFile, bankbookFile].filter((file) => file instanceof File);
    const hasUnsupportedFile = selectedFiles.some((file) => !/\.(jpg|jpeg|png|gif|webp|pdf)$/i.test(file.name));
    if (hasUnsupportedFile) {
      showDialog({
        title: '확인',
        message: 'JPG, JPEG, PNG, GIF, WEBP 또는 PDF 파일만 첨부할 수 있습니다.',
        modalType: 'alert',
      });
      return;
    }
    if (selectedFiles.some((file) => file.size > 5 * 1024 * 1024)) {
      showDialog({ title: '확인', message: '첨부 파일은 5MB 이하로 등록해 주세요.', modalType: 'alert' });
      return;
    }

    const formData = new FormData();
    if (identityFile instanceof File) formData.append('identity', identityFile);
    if (bankbookFile instanceof File) formData.append('bankbook', bankbookFile);
    formData.append(
      'param',
      JSON.stringify({
        ...param,
        identityFile: identityFile instanceof File ? null : identityFile,
        bankbookFile: bankbookFile instanceof File ? null : bankbookFile,
      }),
    );

    // 신규 시 신규 업체 등록, 수정 시 수정
    let url = null;
    if (id) url = `/api/account/updateFreeAccount?id=${id}`;
    else url = '/api/account/createFreeAccount';

    try {
      const res = await api.post(url, formData, { timeout: 60000 });
      console.log('res');
      console.log(res);

      // 저장 성공 시 목록 페이지로 이동
      if (res.status === 200) navigate('/account/freeAccountList');
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || '프리랜서 정보 저장에 실패했습니다.';
      showDialog({ title: '저장 실패', message, modalType: 'alert' });
      console.error('프리랜서 정보 저장 실패:', err);
    }
  };

  // 취소
  const handleCancel = () => {
    navigate('/account/freeAccountList');
  };

  useEffect(() => {
    if (id) {
      // 수정 시에 아이디에 맞는 데이터 조회
      api.get(`/api/account/readAccount?id=${id}`).then((res) => {
        console.log('res');
        console.log(res);

        if (res.status === 200) {
          const account = res?.data?.result?.account?.[0];
          const tempParam = {
            personName: account?.person_name,
            phone: account?.tel,
            email: account?.email,
            bank: account?.account_bank_name,
            accountNumber: account?.account_bank_no,
            identityFile: account?.id_card_url,
            bankbookFile: account?.bankbook_url,
          };

          setParam(tempParam);
        }
      });
    }
  }, [id]);

  return (
    <React.Fragment>
      <FreeAccountCreateTable param={param} setParam={setParam} />
      <CustomStack justifyContent="center" mt={4}>
        <CustomButton color="gray" onClick={handleCancel}>
          취소
        </CustomButton>
        <CustomButton onClick={handleSave}>저장</CustomButton>
      </CustomStack>
    </React.Fragment>
  );
};

export default FreeAccountCreate;
